'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CwAttachmentUpload = require('./CwAttachmentUpload.scss');

var _CwAttachmentUpload2 = _interopRequireDefault(_CwAttachmentUpload);

var _CwFileUpload = require('../../components/cwfileupload/CwFileUpload');

var _CwFileUpload2 = _interopRequireDefault(_CwFileUpload);

var _CwFileImage = require('../../components/cwfileimage/CwFileImage');

var _CwFileImage2 = _interopRequireDefault(_CwFileImage);

var _CwUploader = require('../../components/cwuploader/CwUploader');

var _CwUploader2 = _interopRequireDefault(_CwUploader);

var _CwImage = require('../../components/cwimage/CwImage');

var _CwImage2 = _interopRequireDefault(_CwImage);

var _IconPath = require('../../utils/IconPath');

var _IconPath2 = _interopRequireDefault(_IconPath);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CwAttachmentUpload = function (_Component) {
  (0, _inherits3.default)(CwAttachmentUpload, _Component);

  function CwAttachmentUpload() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, CwAttachmentUpload);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CwAttachmentUpload.__proto__ || (0, _getPrototypeOf2.default)(CwAttachmentUpload)).call.apply(_ref, [this].concat(args))), _this), _this.onFileChanged = function (files) {
      var newValue;

      if (!_this.props.value) {
        newValue = [];
      } else {
        newValue = _this.props.value.slice(0);
      }

      for (var i = 0; i < files.length; i++) {
        newValue.push(files[i]);
      }

      _this.props.onChange(newValue);
    }, _this.getItemPreview = function (item) {
      if (item.type === 'image/png' || item.type === 'image/jpeg' || item.type === 'image/bmp' || item.type === 'image/gif' || item.type === 'image/svg+xml') {
        return _react2.default.createElement(_CwFileImage2.default, { className: _CwAttachmentUpload2.default.imageIcon, file: item });
      } else {
        return _react2.default.createElement(_CwImage2.default, { className: (0, _classnames2.default)(_CwAttachmentUpload2.default.imageIcon, _CwAttachmentUpload2.default.attachmentIcon), src: _this.props.attachmentIcon });
      }
    }, _this.customizeUploader = function (uploader) {
      return _react2.default.createElement(
        _CwFileUpload2.default,
        { disabled: _this.props.disabled, onFileChanged: _this.onFileChanged, accept: _this.props.accept, multiple: _this.props.multiple },
        uploader
      );
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(CwAttachmentUpload, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_CwUploader2.default, {
        cwId: this.props.cwId,
        value: this.props.value,
        onChange: this.props.onChange,
        disabled: this.props.disabled,
        invalid: this.props.invalid,
        uploadIcon: this.props.uploadIcon,
        closeIcon: this.props.closeIcon,
        uploadText: this.props.uploadText,
        multiple: this.props.multiple,
        customizeUploader: this.customizeUploader,
        getItemPreview: this.getItemPreview
      });
    }
  }]);
  return CwAttachmentUpload;
}(_react.Component);

CwAttachmentUpload.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: _propTypes2.default.string,
  value: _propTypes2.default.arrayOf(_propTypes2.default.object),
  onChange: _propTypes2.default.func,
  disabled: _propTypes2.default.bool,
  uploadIcon: _propTypes2.default.string,
  closeIcon: _propTypes2.default.string,
  uploadText: _propTypes2.default.string,
  /**
  * Used to control if field is valid
  */
  invalid: _propTypes2.default.bool,
  /**
   * Determines which file types can be uploaded
   * accepts file extensions, media types, and 
   * audio/*|video/*|image/*
   */
  accept: _propTypes2.default.string,
  /**
   * Allows multiple file upload if true
   */
  multiple: _propTypes2.default.bool,
  /**
   * Default attachment preview icon used for non-image uploads
   */
  attachmentIcon: _propTypes2.default.string
};

CwAttachmentUpload.defaultProps = {
  attachmentIcon: _IconPath2.default.get('Action_Attach')
};

exports.default = CwAttachmentUpload;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui/lib/components/cwattachmentupload/CwAttachmentUpload.js
// module id = 820
// module chunks = 10